import { ExplainerImageConfig } from "../types/explainer";
import { useBreakpoint } from "./use-breakpoint";

/**
 * Custom hook to determine the appropriate image size based on viewport
 * Uses breakpoint information to select the correct dimensions
 *
 * @param imageConfig - The image configuration containing size information
 * @returns The appropriate width and height for the current viewport
 */
export const useResponsiveImageSize = (
  imageConfig: ExplainerImageConfig | undefined
) => {
  const { isBelowSm } = useBreakpoint("sm");
  const { isBelowMd } = useBreakpoint("md");
  const { isBelowLg } = useBreakpoint("lg");
  const { isBelowXl } = useBreakpoint("xl");

  if (!imageConfig?.size) return undefined;

  const { sm, md, lg, xl, xxl } = imageConfig.size;

  // Return the appropriate size based on the current viewport
  if (isBelowSm) return { width: sm.width, height: sm.height };
  if (isBelowMd) return { width: md.width, height: md.height };
  if (isBelowLg) return { width: lg.width, height: lg.height };
  if (isBelowXl) return { width: xl.width, height: xl.height };
  return { width: xxl.width, height: xxl.height };
};
